import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, OnDestroy, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ServiceRestServices from '../../services/service-rest.service';
import AngularStateHelperService from '../../services/angular-state-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { MatSidenavModule, MatDrawer } from '@angular/material/sidenav';
import { Subscription, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	standalone: true,
	selector: 'drawer-notes',
	templateUrl: './drawer-notes.component.html',
	imports: [ CommonModule, MatSidenavModule, TranslatePipe, FormsModule ]
})
export class DrawerNotesComponent implements OnInit, OnDestroy {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@ViewChild('notesDrawer') notesDrawer: MatDrawer;
	
	saveSubject: Subject<string> = new Subject<string>();
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
		this.vm.initialized = false;
		this.vm.notes = {};
		
		this.saveSubject.pipe(
			debounceTime(500)
		).subscribe(searchTerm => {
			this.save();
		});
	}
	
	ngOnInit() {
		this.vm.uid = 'dn-' + Date.now();
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, "toggleNotesDrawer", (event, data) => {
					this.vm.notes = data;
					this.vm.isOpen = this.vm.notes.open;
					if (this.vm.isOpen) {
						this.angularStateHelperService.setGlobalProperty('noDocScroll', true);
						this.swapScroller(true);
						this.notesDrawer.open();
					} else {
						this.close();
					}
				})
		);
		
		this.vm.save = this.save;
		this.vm.close = this.close;
		this.vm.initialized = true;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	onNotesChange(data: string) {
		this.saveSubject.next(data);
	}
	
	save() {
		this.serviceRestServices.saveAppointmentNotes(this.vm.notes.data);
	}
	
	close() {
		this.vm.notes.open = false;
		this.angularStateHelperService.setGlobalProperty('noDocScroll', false);
		this.swapScroller(false);
		this.notesDrawer.close();
	}

	swapScroller(value) {
		if (value) {
			document.body.classList.add("u-no-scroll");
		} else {
			document.body.classList.remove("u-no-scroll");
		}
	}
	
}